import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import { fetchDownloadExhibitorInfo } from "ActionsExhibitors";
import { COMMON_FAIL_MESSAGE } from "Constants";
import Loader from "Loader";
import LocaleStrings from "Languages";

class ExportExhibitor extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);

    this.state = { loading: false, showModal: { show: false } };
  }

  openModal() {
    this.setState({ loading: false, showModal: { show: true } });
  }

  closeModal() {
    this.setState({ showModal: { show: false } });
  }

  downloadCSV = () => {
    let { session } = this.props;

    this.setState({ loading: true });
    this.props.fetchDownloadExhibitorInfo(session, (response) => {
      if (response.success) {
        this.setState({ loading: false });
        this.closeModal();
        if (response.data && !_.isEmpty(response.data)) {
          this.props.JSONToCSVConvertor(response.data, true);
        } else {
          this.props.showError(LocaleStrings.no_data_found);
        }
      } else {
        this.props.showError(COMMON_FAIL_MESSAGE);
        this.setState({ loading: false });
      }
    });
  };

  render() {
    let { exhibitorsCount } = this.props;
    let { loading, showModal } = this.state;

    return (
      <div>
        <div className="">
          <Button
            type="button"
            className="btn-custom-blue"
            onClick={this.openModal}
          >
            <i className="fa fa-download i-custom-ms" aria-hidden="true"></i>{" "}
            {LocaleStrings.button_csv_export}
          </Button>
        </div>
        <div>
          <Modal
            className="modal-container"
            show={showModal.show === true ? true : false}
            onHide={this.closeModal}
            animation={true}
          >
            <Modal.Header>
              <div className="import-modal-title">
                {LocaleStrings.exhibitor_export_modal_title}
              </div>
              <button
                type="button"
                className="i-custom-cross-popup pull-right"
                onClick={() => this.closeModal()}
              >
                <img
                  className="i-custom-small"
                  src="../../style/images/custom-icons/cross-black.png"
                  alt="close"
                />
              </button>
            </Modal.Header>
            <Modal.Body>
              <div style={{ textAlign: "center" }}>
                {loading ? (
                  <div className="">
                    <Loader />
                    <div className="loader-info">
                      {LocaleStrings.exhibitor_export_text_preparing_data}
                    </div>
                  </div>
                ) : (
                  <div className="">
                    {LocaleStrings.exhibitor_export_text_export_csv_description}
                    <p style={{ fontSize: "x-large" }}>
                      {_.replace(
                        LocaleStrings.exhibitor_export_total_data_text,
                        "#total",
                        exhibitorsCount.totalexhibitors
                      )}
                    </p>
                  </div>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              {exhibitorsCount.totalexhibitors > 0 ? (
                <Button
                  type="button"
                  className="btn btn-custom-blue"
                  onClick={this.downloadCSV}
                  loading={loading}
                  disabled={loading}
                >
                  {LocaleStrings.button_download}
                </Button>
              ) : (
                <Button
                  className="btn btn-custom-white"
                  onClick={this.closeModal}
                >
                  {LocaleStrings.sponsor_close}
                </Button>
              )}
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    exhibitorsCount: state.exhibitorsCount,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  fetchDownloadExhibitorInfo,
})(ExportExhibitor);
